import { FilterBar } from "@/components/data";
import type { FilterSpec } from "@/components/data";
import type { Grain } from "../api";

const GRAIN_SPEC: FilterSpec = {
  name: "grain",
  label: "Grain",
  kind: "choice",
  options: [
    { value: "week", label: "Week" },
    { value: "month", label: "Month" },
  ],
};

/**
 * The Week | Month segmented control (cvce-pipeline-4 spec, Scope "Control").
 * Built on the shared `FilterBar`'s `segmented` layout rather than a new
 * component — that layout already gives a two-option chip group that always
 * carries a value and never shows a "Clear" button, which is exactly this
 * control's contract.
 */
export function GrainToggle({ grain, onChange }: { grain: Grain; onChange: (grain: Grain) => void }) {
  return (
    <FilterBar
      layout="segmented"
      filters={[GRAIN_SPEC]}
      values={{ grain }}
      onChange={(next) => onChange(next.grain === "month" ? "month" : "week")}
    />
  );
}
